import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=2afb28ba&scoped=true&"
import script from "./OrderOverview.vue?vue&type=script&lang=ts&"
export * from "./OrderOverview.vue?vue&type=script&lang=ts&"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=2afb28ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb28ba",
  null
  
)

export default component.exports